// import * as _linkifyHtml from 'linkifyjs/html';
// tslint:disable-next-line:no-duplicate-imports
import { default as _rollupLinkifyHtml } from 'linkifyjs/html';

// export const linkifyHtml = _rollupLinkifyHtml || _linkifyHtml;
export const linkifyHtml = _rollupLinkifyHtml;
